var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-profile-cover section-shaped my-0"},[_c('div',{staticClass:"shape shape-style-1 shape-default shape-skew alpha-4"},_vm._l((_vm.dots),function(n){return _c('span',{key:n})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }